import type { ReactNode } from 'react';

import { cn } from '@/utils/styles';

/**
 * Props for {@link PlainLayout}.
 */
export type PlainLayoutProps = {
  /** Renders the root element as `<main>` instead of `<div>` for page-level semantics. Defaults to `false`. */
  main?: boolean;
  /** Additional classes applied to both the root element and its inner wrapper. */
  className?: string;
  /** Content rendered inside the layout. */
  children: ReactNode;
};

/**
 * A minimal full-size root layout wrapper for standalone pages (e.g. sign-in, workbench, data-harmonization).
 * @param props - {@link PlainLayoutProps}
 */
export function PlainLayout({ main = false, children, className }: PlainLayoutProps) {
  const Comp = main ? 'main' : 'div';

  return (
    <Comp className={cn('relative size-full overflow-hidden', className)}>
      <div className={cn('isolate size-full', className)}>{children}</div>
    </Comp>
  );
}
